"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=stock-rack.dto.js.map